import React from 'react';
import { Wrapper, Drawer } from '@/components';
import { i18n, thumbnail7n, priceFormat } from '@/utils';
import { Shop } from '@/sunzi';
import { RelatedProductIncrement } from '@/increment/increment';
import Icon from './icon';
import styles from './style.less';

interface RelatedProductProps {
  /** 商店信息 */
  shop: Shop;
  /** 增值产品 */
  relatedProduct: RelatedProductIncrement;
  /** 关闭回调 */
  onClose: () => void;
  /** 确认回调 */
  onConfirm: (addStatus: boolean) => void;
}

const RelatedProduct: React.FC<RelatedProductProps> = ({
  shop,
  relatedProduct,
  onClose,
  onConfirm,
}) => {

  return (
    <Wrapper className={styles.relatedProduct}>
      <Drawer
        mask
        className={styles.relatedProductDrawer}
      >
        <div className={styles.drawerContent}>
          <div className={styles.imageWrapper}>
            <div
              className={styles.image}
              style={{
                backgroundImage: `url(${thumbnail7n(relatedProduct.thumbnail, 400)})`
              }}
            />
          </div>
          <div className={styles.previous} onClick={onClose}>
            <Icon type="arrow-left" color="#000" size={30} />
          </div>
          <div className={styles.title}>
            {relatedProduct.title}
          </div>
          <div className={styles.price}>
            + {priceFormat(shop.currencySymbol, relatedProduct.price)}
          </div>
          <div className={styles.buttonGroup}>
            <div
              className={styles.confirm}
              onClick={() => onConfirm(true)}
            >
              <span>
                {i18n.format('modules.mini.me.sure.add.cart')}
              </span>
            </div>
            <div className={styles.divider}>
              <span>
                {i18n.format('modules.mini.me.or')}
              </span>
            </div>
            <div
              className={styles.denied}
              onClick={() => onConfirm(false)}
            >
              <span>
                {i18n.format('modules.mini.me.no.thanks')}
              </span>
            </div>
          </div>
        </div>
      </Drawer>
    </Wrapper>
  );
}

export default RelatedProduct;
